import { useQuery } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import type { PlansResponse } from "./types";

export const usePlansQuery = () => {
  const fetch = useAuthFetch();
  return useQuery({
    queryKey: ["api", "tribute", "plans"],
    staleTime: 1000 * 60 * 30,
    queryFn: async () => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/tribute/plans`
      );
      const data: PlansResponse = await response.json();
      return data;
    },
  });
};
